import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

/**
 * デジタル社員証表示コンポーネント
 * props.employee: { name, departmentName, positionName, employeeId }
 * props.qrPayload: 設計書 9章の HMAC-SHA256 署名付き QR ペイロード（JSON オブジェクト）
 *   例: { employee_id: "S002", iat: ..., exp: ..., sig: "..." }
 *   未指定時は employee_id の平文にフォールバック
 */
export default function IDCard({ employee, qrPayload }) {
  const { name = '', departmentName = '', positionName = '', employeeId = '' } = employee || {};
  const qrValue = qrPayload
    ? JSON.stringify(qrPayload)
    : employeeId
    ? `employee:${employeeId}`
    : '';

  return (
    <div className="max-w-sm mx-auto bg-white rounded-2xl shadow-lg overflow-hidden border border-slate-200">
      <div className="bg-emerald-600 px-4 py-3 text-white text-center font-semibold">
        社員証
      </div>
      <div className="p-5 space-y-4">
        <div className="flex justify-center">
          <div className="w-20 h-20 rounded-full bg-slate-200 flex items-center justify-center text-2xl font-bold text-slate-500">
            {name ? name.charAt(0) : '?'}
          </div>
        </div>
        <div className="text-center space-y-1">
          <p className="text-lg font-bold text-slate-800">{name || '—'}</p>
          <p className="text-sm text-slate-600">{departmentName || '—'}</p>
          <p className="text-sm text-slate-600">{positionName || '—'}</p>
          <p className="text-xs text-slate-500">社員番号: {employeeId || '—'}</p>
        </div>
        {qrValue && (
          <div className="flex justify-center pt-2">
            <QRCodeSVG value={qrValue} size={120} level="M" />
          </div>
        )}
      </div>
    </div>
  );
}
